import { BaseButtonProps } from 'antd/es/button/button'
import React, { FunctionComponent, memo, useMemo } from 'react'

import { LabelConnectionFragment, LabelKey } from '../../utils/labelsTypes'
import { InlineLabelsGroup } from '../InlineLabelsGroup/InlineLabelsGroup'
import { TableCellEditLabelModal } from '../TableCellEditLabelModal/TableCellEditLabelModal'

export interface TableCellLabelsProps {
  labels: LabelConnectionFragment
  refetch?: () => void
  modalTitle?: string
  buttonText?: React.ReactNode
  buttonProps?: BaseButtonProps
  recordId: string
  labelEntityType: LabelKey
  alignment?: 'labelFirst' | 'optionFirst'
}

export const TableCellLabels: FunctionComponent<TableCellLabelsProps> = memo(
  props => {
    const label = useMemo(
      () => props.labels?.nodes?.map(label => label?.labelByLabelId),
      [props.labels]
    )
    const sortedLabels = useMemo(() => {
      return [...(label || [])].sort((a, b) => {
        const nameA = a?.name || ''
        const nameB = b?.name || ''
        return nameA.localeCompare(nameB)
      })
    }, [label])

    return (
      <div
        className={`${
          props.alignment === 'labelFirst' ? 'flex-row-reverse' : ''
        } flex space-x-2`}
      >
        <TableCellEditLabelModal
          buttonText={props.buttonText}
          buttonProps={props.buttonProps}
          labels={props.labels}
          refetch={props?.refetch}
          modalTitle={props.modalTitle}
          recordId={props.recordId}
          labelEntityType={props.labelEntityType}
        />
        <InlineLabelsGroup
          labels={sortedLabels}
          labelEntityType={props.labelEntityType}
        />
      </div>
    )
  }
)
